module.exports = __webpack_public_path__ + "static/shift-66c85234c28783c5d5f5962ca35500ec.png";